import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box, Collapse, IconButton, Table, TableBody, TableHead, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { AlertSpg, isArrayEmpty, isArrayNotEmpty, OptionTableCell, TableButton } from "@duosoftbg/nacid-components";
import {
  openDeleteModal,
  openEditModal,
} from "../../../../../store/redux/slice/ComponentsControl/homePageCategoryControl";
import { homePageCategorySection } from "../../../../../utils/constants";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { homePageCategoryLinkCreationInitialValues } from "../../../../../init/homePageCategoryLinkCreationInitialValues";

const HomePageCategoryRow = ({ category }) => {
  const dispatch = useAppDispatch();
  const [openLinkRow, setOpenLinkRow] = useState(false);
  const { t } = useTranslation();
  const links = category.links;
  return (
    <Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenLinkRow(!openLinkRow)}>
            {openLinkRow ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{category.name}</TableCell>
        <TableCell>{category.nameEn}</TableCell>
        <TableCell>{category.order}</TableCell>
        <OptionTableCell>
          <TableButton
            type={"edit"}
            onClick={() => {
              dispatch(
                openEditModal({
                  section: homePageCategorySection.category,
                  object: { ...category },
                }),
              );
            }}
          />
          <TableButton
            onClick={() => {
              dispatch(
                openDeleteModal({
                  section: homePageCategorySection.category,
                  id: category.id,
                }),
              );
            }}
            type={"remove"}
          />
        </OptionTableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openLinkRow} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                {t("l.table.head.links")}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead style={{ background: "#eee" }}>
                  <TableRow>
                    <TableCell>{t("l.table.head.description")}</TableCell>
                    <TableCell>{t("l.table.head.descriptionEn")}</TableCell>
                    <TableCell>{t("l.table.head.position")}</TableCell>
                    <TableCell align="right">
                      <TableButton
                        type={"create"}
                        onClick={() => {
                          dispatch(
                            openEditModal({
                              section: homePageCategorySection.link,
                              object: { ...homePageCategoryLinkCreationInitialValues, categoryId: category.id },
                            }),
                          );
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isArrayNotEmpty(links) && (
                  <TableBody>
                    {links.map((link) => (
                      <TableRow key={link.id}>
                        <TableCell>{link.name}</TableCell>
                        <TableCell>{link.nameEn}</TableCell>
                        <TableCell>{link.order}</TableCell>
                        <OptionTableCell>
                          <TableButton
                            type={"edit"}
                            onClick={() => {
                              dispatch(
                                openEditModal({
                                  section: homePageCategorySection.link,
                                  object: { ...link, categoryId: category.id },
                                }),
                              );
                            }}
                          />
                          <TableButton
                            onClick={() => {
                              dispatch(
                                openDeleteModal({
                                  section: homePageCategorySection.link,
                                  id: link.id,
                                }),
                              );
                            }}
                            type={"remove"}
                          />
                        </OptionTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
              {isArrayEmpty(links) && <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default HomePageCategoryRow;
